import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": "alert-inner--icon"
};
var _hoisted_2 = {
  key: 1,
  "class": "alert-inner--text"
};
var _hoisted_3 = {
  key: 0,
  "class": "alert-inner--icon"
};
var _hoisted_4 = {
  key: 1,
  "class": "alert-inner--text"
};

var _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true"
}, "×", -1);

var _hoisted_6 = [_hoisted_5];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $data.visible ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    "class": _normalizeClass(["alert", ["alert-".concat($props.type), {
      'alert-dismissible': $props.dismissible
    }]]),
    role: "alert"
  }, [!$props.dismissible ? _renderSlot(_ctx.$slots, "default", {
    key: 0
  }, function () {
    return [$props.icon ? (_openBlock(), _createElementBlock("span", _hoisted_1, [_createElementVNode("i", {
      "class": _normalizeClass($props.icon)
    }, null, 2)])) : _createCommentVNode("", true), _ctx.$slots.text ? (_openBlock(), _createElementBlock("span", _hoisted_2, [_renderSlot(_ctx.$slots, "text")])) : _createCommentVNode("", true)];
  }) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_renderSlot(_ctx.$slots, "default", {}, function () {
    return [$props.icon ? (_openBlock(), _createElementBlock("span", _hoisted_3, [_createElementVNode("i", {
      "class": _normalizeClass($props.icon)
    }, null, 2)])) : _createCommentVNode("", true), _ctx.$slots.text ? (_openBlock(), _createElementBlock("span", _hoisted_4, [_renderSlot(_ctx.$slots, "text")])) : _createCommentVNode("", true)];
  }), _renderSlot(_ctx.$slots, "dismiss-icon", {}, function () {
    return [_createElementVNode("button", {
      type: "button",
      "data-dismiss": "alert",
      "aria-label": "Close",
      "class": "close",
      onClick: _cache[0] || (_cache[0] = function () {
        return $options.dismissAlert && $options.dismissAlert.apply($options, arguments);
      })
    }, _hoisted_6)];
  })], 64))], 2)) : _createCommentVNode("", true);
}